import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { TextComponent } from "./TextComponent";

interface NavItemProps {
	title: string;
	icon?: JSX.Element;
	href?: string;
	variant?: "header" | "primary";
	hiddenText?: boolean;
	className?: string;
	onClick?: () => void;
	marked?: boolean;
}

export const NavItem = ({ title, icon, href = "#", variant = "primary", hiddenText = false, onClick, className, marked }: NavItemProps) => {
	const baseClass = `flex px-2 drop-shadow-sm ${className}`;
	const location = useLocation();
	const isActive = variant === "header" ? location.pathname === href : href === "/" ? location.pathname === href : location.pathname.startsWith(href);

	let combinedClass;

	if (variant === "header") {
		combinedClass = `gap-1 transition-colors duration-300 pb-1 pt-1 border-b-2 hover:border-b-primaryViolet hover:text-primaryViolet ${baseClass} ${
			isActive || marked ? "border-b-primaryViolet text-primaryViolet font-bold" : "text-secondaryViolet border-b-transparent"
		}`;
	} else {
		combinedClass = `py-2 max-md:font-bold items-center max-md:px-5 px-4 ${baseClass} ${
			isActive || marked ? "max-md:bg-primaryPorcelain text-primarySunset font-bold" : "text-primaryIvory max-md:hover:bg-gray-100 hover:text-primarySunset transition-colors duration-300"
		}`;
	}

	return (
		<Link
			to={href}
			className={`select-none ${combinedClass}`}
			onClick={onClick}
		>
			{icon}
			<TextComponent
				variant="h5"
				className={`w-fit ${hiddenText && "max-md:hidden"}`}
			>
				{title}
			</TextComponent>
		</Link>
	);
};
